import Editorials from "~/types/editorials";

import SkeletonCartKissesInfo from "./skeleton-cart-kisses-info";
import SkeletonCartPromoCode from "./skeleton-cart-promo-code";
import SkeletonCartTotals from "./skeleton-cart-totals";

type Props = {
  page: Editorials.CartPage | null;
  withImage?: boolean;
};

export default function SkeletonCartRightColumn(props: Props) {
  const { page, withImage } = props;

  return (
    <>
      <SkeletonCartKissesInfo withImage={withImage} page={page} />
      <SkeletonCartPromoCode />
      <SkeletonCartTotals />
    </>
  );
}
